// extracted by mini-css-extract-plugin
module.exports = {"container":"record_container__1T8-x","card":"record_card__UO8YA","row":"record_row__1YUs9"};